import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Link from 'gatsby-link'
import PageWrap from '@components/PageWrap'
import BlockTitle from '@components/BlockTitle'
import Filters from '@components/Filters'
import PlaceHolder from '@assets/svgs/placeholder.svg'
import { productRoute } from '@constants/routes'
import './Category.module.scss'
import { renderHireProductLink } from '@helpers/RenderHireProductLink'
import { supportsWebp } from '@helpers/webp'
const RESET_NAME = 'All'

class Category extends Component {
  state = {
    originalProducts: R.propOr([], 'data', this.props),
    visibleProducts: R.propOr([], 'data', this.props),
    filters: [],
    filter: RESET_NAME,
    format: 'jpg'
  }

  componentDidMount () {
    const { filters } = this.props
    filters.unshift(RESET_NAME)

    this.setState({ filters })
    supportsWebp((isSupported) => {
      if (isSupported) {
        this.setState({format: 'webp'})
      }
    })
  }

  applyFilter = (filter) => {
    if (filter === RESET_NAME) {
      this.resetFilters()
      return
    }
    const { originalProducts } = this.state
    const visibleProducts = originalProducts.filter(product =>
      R.equals(R.path(['node', 'template', '0', 'brand'], product), filter)
    )

    this.setState({ filter, visibleProducts })
  }

  resetFilters () {
    const visibleProducts = this.state.originalProducts
    this.setState({
      visibleProducts,
      filter: RESET_NAME
    })
  }

  renderProduct = (product, index) => {
    const { format } = this.state
    const slug = R.path(['node', 'slug'], product)
    const { title, image, category } = R.path(['node', 'template', '0'], product)
    var src = R.pathOr(null, ['sizes', 'src'], image)
    if (!src.includes('progressive')) {
      src = src + `&fm=${format}`
    }
    const productLink = renderHireProductLink(slug, category)

    return (
      <div key={`${slug}-${index}`} styleName='product'>
        <Link to={productRoute(productLink)}>
          <div styleName='image-wrap'>
            <div
              styleName='image'
              style={{ backgroundImage: `url(${src || PlaceHolder})` }}
            />
          </div>
          <h4 styleName='product-title'>{title}</h4>
        </Link>
      </div>
    )
  }

  render () {
    const { category } = this.props
    const { filters, filter, visibleProducts } = this.state
    const takeTitle = R.path(['node', 'template', '0', 'title'])
    const sorting = (a, b) => R.pipe(
      takeTitle,
      (title) => title.localeCompare(takeTitle(b), undefined, { numeric: true })
    )(a)
    const sortVisibleProducts = visibleProducts.sort((a, b) => sorting(a, b))

    return (
      <PageWrap>
        <BlockTitle title={category} DynamicTag='h1' />
        {R.not(R.isEmpty(sortVisibleProducts)) ? (
          <Fragment>
            <Filters filters={filters} applyFilter={this.applyFilter} currentFilter={filter} />
            <div styleName='products'>
              {sortVisibleProducts.map(this.renderProduct)}
            </div>
          </Fragment>
        ) : <span styleName='none-found'>No products found</span>}
      </PageWrap>
    )
  }
}

Category.propTypes = {
  data: PropTypes.array.isRequired,
  filters: PropTypes.array.isRequired
}

export default Category



// WEBPACK FOOTER //
// ./src/components/HireCategory/Category/Category.js